import useAzureDevOpsDatasourceRepo from '@/composables/integrations/azure-dev-ops/azure-dev-ops-datasource-repo';
import useLoggedInUser from '@/composables/logged-in-user/logged-in-user';
import useRepo from '@/nebula/repo';
import { azureDevOpsQuery as azureDevOpsQueryConfig } from 'shared/api/query/configs.json';
import { customDatasourceProperty } from 'shared/constants.json';

export default function useAzureDevOps() {
  const queryRepo = useRepo(azureDevOpsQueryConfig.model);
  const datasourceRepo = useAzureDevOpsDatasourceRepo();

  const { loggedInUser } = useLoggedInUser();

  const createQuery = (entity) => queryRepo.createSingle({
    ...entity,
    creator: { uid: loggedInUser.value.uid },
  });

  const getProjectsInOrganization = (datasource, organization) => datasourceRepo.getProjectsInOrganization({
    ...datasource,
    [customDatasourceProperty.azureDevOpsOrganizations]: [organization],
  });

  return {
    createQueryLoading: queryRepo.createLoading,
    createQuery,
    updateQueryLoading: queryRepo.updateLoading,
    updateQuery: (entity) => queryRepo.updateSingle(entity, { ignoreResponse: false }),
    deleteQueryLoading: queryRepo.deleteLoading,
    deleteQuery: queryRepo.deleteSingle,
    getProjectsInOrganizationLoading: datasourceRepo.getProjectsInOrganizationLoading,
    getProjectsInOrganization,
  };
}
